import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  AlertController,
  IonContent,
  IonSlides,
  ViewDidEnter,
  ViewWillEnter,
} from '@ionic/angular';
import * as leaflet from 'leaflet';
import { MenuCategory, MenuItem } from 'src/app/models/rich-data.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { DataService } from 'src/app/services/data.service';
import { GetTranslationService } from 'src/app/services/get-translation.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { OneSignalService } from 'src/app/services/one-signal.service';
import { environment } from 'src/environments/environment';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent implements OnInit, ViewDidEnter, ViewWillEnter {
  @ViewChild('content') content: IonContent;
  @ViewChild('slider') slides: IonSlides;

  userLang: string = localStorage.getItem('userLang');

  sliderOpts = {
    speed: 300, //0.3s transition
    autoplay: { delay: 7000, active: true, speed: 700 },
    slidesPerView: 1,
  };

  config: SwiperOptions = {
    slidesPerView: 1,
    pagination: { clickable: true },
    speed: 300, //0.3s transition
    autoplay: { delay: 7000 },
  };

  fullPageSlider = {
    initialSlide: 0,
  };

  icon = {
    icon: leaflet.icon({
      iconSize: [41, 41],
      iconAnchor: [13, 0],
      iconUrl: 'assets/media/marker.svg',
    }),
  };

  center: google.maps.LatLngLiteral = {
    lat: +this.dataServ.rData?.lat_lng?.split(',')[0],
    lng: +this.dataServ.rData?.lat_lng?.split(',')[1],
  };

  didInit = false;
  processing = false;
  fullImage = false;

  locations: {
    location: any;
    title: string;
    subtitle: string;
    item: MenuItem;
  }[] = [];

  marker: google.maps.LatLngLiteral[] = [{ lat: 0, lng: 0 }];

  oneSignalId: string = localStorage.getItem('oneSignal') || ' ';
  version: string = environment.version;

  constructor(
    public dataServ: DataService,
    public modalServ: ModalMakerService,
    private analytics: AnalyticsService,
    private caption: CaptionPipe,
    private titleService: Title,
    private translate: GetTranslationService,
    private alertctrl: AlertController,
    private router: Router
  ) {}

  async ngOnInit() {
    if (!this.dataServ.rData) {
      await this.dataServ.getRichData();
    }

    // oneSignal değerini tekrar alma
    this.oneSignalId = localStorage.getItem('oneSignal') || ' ';
    
    this.didInit = true;
  }

  ionViewWillEnter(): void {
    // oneSignal değerini her sayfaya girişte kontrol etme
    this.oneSignalId = localStorage.getItem('oneSignal') || ' ';
    
    this.titleService.setTitle(
      this.caption.transform(this.dataServ.rData.name, 'en')
    );

    for (const KEY in this.dataServ.rData) {
      if (
        this.dataServ.rData[KEY] &&
        this.dataServ.rData[KEY].show &&
        this.dataServ.rData[KEY].menu_categories
      ) {
        (this.dataServ.rData[KEY].menu_categories as MenuCategory[]).forEach(
          (category) => {
            if (category.menu_items) {
              category.menu_items.forEach((item) => {
                if (item.activate_map_location) {
                  if (item.map_location) {
                    this.locations.push({
                      location: [
                        +item.map_location.split(',')[0],
                        +item.map_location.split(',')[1],
                      ],
                      title: this.caption.transform(item.name),
                      subtitle: this.caption.transform(
                        item.location_description
                      ),
                      item,
                    });
                  }
                }
              });
            }
          }
        );
      }
    }
  }
  async ionViewDidEnter() {
    setTimeout(() => {
      this.didInit = true;

      try {
        setTimeout(() => {
          this.slides?.update();
        }, 500);
      } catch {}

      //! This area commented because google map was used instead of leaflet
      // if (this.dataServ.rData.lat_lng && this.dataServ.rData.lat_lng) {
      //   const MAP = leaflet.map('map').setView([Number(this.dataServ.rData.lat_lng.split(',')[0]),
      //   Number(this.dataServ.rData.lat_lng.split(',')[1])], 48);

      //   leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      //     attribution: ''
      //   }).addTo(MAP);

      //   leaflet.marker([Number(this.dataServ.rData.lat_lng.split(',')[0]),
      //   Number(this.dataServ.rData.lat_lng.split(',')[1])], this.icon)
      //     .addTo(MAP);
      // }
    }, 300);

    document.querySelectorAll('ion-button').forEach((btn) => {
      btn.addEventListener('click', (event: Event) => {
        this.analytics.eventEmitter(
          `${this.caption.transform(
            this.dataServ.rData.name,
            this.dataServ.rData.hotel_language || 'tr'
          )}_${(event.target as HTMLElement).getAttribute('label')}`,
          'button',
          'click',
          `${this.caption.transform(
            this.dataServ.rData.name,
            this.dataServ.rData.hotel_language || 'tr'
          )}_click`,
          this.dataServ.rData.id
        );
      });
    });
  }

  async scrollDetail() {
    const SCROLLY = (await this.content.getScrollElement()).clientHeight;

    this.content.scrollToPoint(0, SCROLLY, 300);
  }

  async resButton(): Promise<void> {
    this.processing = true;
    await this.modalServ.resButton();
    this.processing = false;
  }

  async open(item: MenuItem) {
    const DETAIL = await this.translate.getTranslate('Detail');
    const CLOSE = await this.translate.getTranslate('Close');
    let header = this.caption.transform(item.name);
    const TEXT = this.caption.transform(item.location_description);

    if (!header) {
      header = this.caption.transform(item.name, 'tr');
    }

    const ALERT = await this.alertctrl.create({
      header,
      message: TEXT,
      buttons: [
        {
          text: CLOSE,
          handler: () => {
            ALERT.dismiss();
          },
        },
        {
          text: DETAIL,
          handler: () => {
            this.router.navigateByUrl(
              `/home/${item.menu_section_id}/${item.id}`
            );
          },
        },
      ],
    });

    await ALERT.present();
  }

  async copyToClipboard(text: string) {
    if (!text) return;
    
    try {
      await navigator.clipboard.writeText(text);
      // İsteğe bağlı: Kopyalandığını göstermek için bir toast veya kısa mesaj gösterebiliriz
      const toast = await this.alertctrl.create({
        message: 'Kopyalandı',
        animated: true,
        cssClass: 'copy-toast',
      });
      await toast.present();
    } catch (err) {
      console.error('Kopyalama başarısız oldu', err);
    }
  }
}
